module.exports = __webpack_public_path__ + "static/media/tier-5.d6664eb6.jpg";